import React from 'react';
import { Checkbox } from 'antd';
import styled from 'styled-components';

interface Iprops {
  isChecked: boolean | null;
}

const CheckboxStyled: React.FC<Iprops> = ({ isChecked }) => {
  return (
    <Wrapper>
      <CustomCheckbox
        style={{
          cursor: 'default',
        }}
        checked={isChecked ? true : false}
      />
    </Wrapper>
  );
};

export default CheckboxStyled;

const Wrapper = styled.div`
  width: fit-content;
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 17px;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.445);
    left: 0;
    top: 2px;
    border-radius: 5px;
  }
`;

const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-wrapper,
  .ant-checkbox,
  .ant-checkbox .ant-checkbox-input,
  .ant-checkbox {
    cursor: default !important;
  }

  & .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #3062d4;
    border-color: #3062d4;
  }
  .ant-checkbox-checked .ant-checkbox-inner:after {
    border-color: #ffffff !important;
  }
  .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner,
  .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover
    .ant-checkbox-inner {
    border-color: #d9d9d9 !important;
  }
`;
